module.exports = __webpack_public_path__ + "img/Strip-Front-B3-Jb.07be927f.png";